<template>
  <main role="main">
    <section>
      <!-- Quản lý lưu trữ -->
      <!-- Dung lượng đã sử dụng / Dung lượng tối đa và thanh tiến trình -->
      <b-row v-if="activeCustomerSubscription">
        <b-col :md="showAiQuota ? 6 : 12">
          <div class="px-4 py-3 border rounded">
            <h5 class="mb-2">{{ $t("yourStorageCapacity") }}</h5>
            <!-- <div v-if="isCustomer() || isCustomerUser()" class="text-small">
              {{ $t("upgradePlanDescription") }}
            </div> -->
            <b-progress class="my-2" :max="storageMaxValue">
              <b-progress-bar :value="storageUsedValue" :style="{ backgroundColor: storageStatusColor }"
                :label="`${Math.round((storageUsedValue / storageMaxValue) * 100)}%`" />
            </b-progress>
            <div class="text-small">
              {{ $t("displayStorageUsed", {
                used: storageUsedValue, total: storageMaxValue
                }) }} ({{ $t("freeStorage", { storage: Math.max(0, storageMaxValue - storageUsedValue).toFixed(2) }) }})
            </div>
            <div v-if="isCustomer() || isCustomerUser()" class="text-small">
              {{ $t("attention") }}: {{ $t("storageExpiredDay", {day: storageRetentionValue}) }}
            </div>
          </div>
        </b-col>

        <b-col md="6" v-if="showAiQuota">
          <div class="px-4 py-3 border rounded">
              <h5 class="mb-2">{{ $t("quotaTotal") }}</h5>
              <b-progress class="my-2" :max="aiQuotaProgressMax" >
                <b-progress-bar
                  :value="aiQuotaProgressValue"
                  :style="{ backgroundColor: aiQuotaStatusColor }"
                  :label="aiQuotaProgressLabel"/>
              </b-progress>
              <div>
                <div v-if="isAiUnlimited" class="text-small">
                  <div>
                    {{ $t("displayQuotaUsed", { used: aiQuotaUsedMinutes }) }}
                  </div>
                  {{ $t("aiQuotaUnlimited") }}
                </div>
                <div v-else class="text-small">
                  {{ $t("displayQuotaUsedAndTotal", { used: aiQuotaUsedMinutes, total: aiQuotaTotalMinutes }) }} ({{ $t("freeQuota", { remaining: aiQuotaRemainingMinutes }) }})
                </div>
              </div>
              <div class="text-small" v-if="!isAiUnlimited && (isCustomer() || isCustomerUser())">
                {{ $t("storageQuotaReset", { date: aiQuotaCycleStartFormatted }) }}
              </div>
          </div>
        </b-col>
      </b-row>
      <!-- Quản lý ghi hình cuộc họp (trong 90 ngày gần nhất) -->
      <div class="record mt-2 px-4 py-0">
        <b-row class="d-flex align-items-center">
          <div>
            <h5 class="mb-0">{{ $t("manageRecordings") }} ({{ meetingRecording.length }})</h5>
            <span class="text-small mb-2">
              {{ $t("recordingRetentionNotice") }}
            </span>
          </div>
          <div class="ml-auto" v-if="meetingRecording.length > 0 && (isCustomer() || isCustomerUser())">
            <b-button variant="outline-danger" @click="onClickDeleteAll()">
              <b-icon icon="trash"></b-icon> {{ $t("deleteAllData") }}
            </b-button>
          </div>
        </b-row>
      </div>
      <!-- Danh sách ghi hình cuộc họp (trong 90 ngày gần nhất) -->
      <div class="px-4 pb-3 recording-list" v-if="meetingRecording.length > 0">
        <div class="d-flex align-items-start py-3 border-bottom recording-item" v-for="(item, index) in meetingRecording"
          :key="item.id">
          <span class="font-weight-bold mr-3 mt-1 text-dark fs-16" style="min-width: 20px;">{{ index + 1 }}</span>
          <div class="flex-grow-1">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <router-link :to="`/meetings/details/${item.id}`" target="_blank" class="recording-link">
                  {{ item.name }}
                </router-link>
                <div class="mt-1 fs-12" style="color: #212529;">
                  ID: {{ item.id }} | {{ getStartDate(item.actualStartTime) }} | 
                  {{ gettHour(item.actualStartTime) }} - {{ gettHour(item.actualEndTime) }} | 
                  {{ convertToByte(item.recordingSize) }}MB
                </div>
              </div>
              <div class="d-flex align-items-center recording-actions ml-3" v-if="(isCustomer() || isCustomerUser())">
                <b-icon icon="download" class="mx-2 cursor-pointer action-icon" style="width:16px;height:16px;"
                  @click="onClickDownload(item)" v-b-tooltip.hover :title="$t('download')" />
                <b-icon icon="play" class="mx-2 cursor-pointer action-icon" style="width:20px;height:20px;"
                  @click="loadRecordingUrl(item)" v-b-tooltip.hover :title="$t('view')"></b-icon>
                <b-icon icon="trash" class="mx-2 cursor-pointer action-icon text-danger" style="width:16px;height:16px;"
                  @click="onClickDeleteRecording(item)" v-b-tooltip.hover :title="$t('delete')"></b-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </main>
</template>

<style lang="scss" scoped>

.settings {
  margin-bottom: 0 !important;
}

.text-small {
  font-size: 12px !important;
}

.recording-list {
  max-height: 60vh;
  overflow-y: scroll;
}

.w-10 {
  width: 100%;
}

.truncate-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* Giới hạn 2 dòng */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  /* Cho phép xuống dòng */
  word-break: break-word;
  /* Ngắt từ nếu quá dài */
}

.progress-custom {
  height: 16px;
  border-radius: 8px;
  background-color: #eef2f7;
  overflow: hidden;
}

::v-deep .progress-custom .progress-bar {
  font-size: 11px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  border-radius: 8px;
}

.recording-item {
  transition: background-color 0.2s;
}

.recording-item:hover {
  background-color: #f8f9fa;
}

.recording-link {
  color: #004F9E;
  font-weight: 500;
  font-size: 16px;
  text-decoration: underline;
}

.recording-link:hover {
  text-decoration: underline;
  color: #004085;
}

.action-icon {
  color: #212529;
  // transition: color 0.2s, transform 0.1s;
}

.action-icon:hover {
  color: #007bff;
  // transform: scale(1.15);
}

.action-icon.text-danger:hover {
  color: #dc3545;
}

.fs-12 {
  font-size: 12px;
}

.fs-16 {
  font-size: 16px;
}

.record {
  padding-top: 16px !important;
}
</style>
<script lang="ts">
import { Component, Prop, Watch } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import * as customerService from "@/service/customerService";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import * as meetingService from "@/service/meetingService";
import moment from "moment";
import { StorageType } from "@/views/enums/storageType";
import * as util from "@/service/util";
import * as aiQuotaUtils from "@/service/aiQuotaUtils";

@Component({

})
export default class ManageStorageModal extends BaseComponent {
  @Prop({ type: String, required: true }) readonly modalId!: string;
  @Prop({ type: [String, Number], required: false }) readonly customerId!: string | number | undefined;

  enumStorageType = StorageType;
  isLoading = false;

  ///Gói cước hoạt động của khách hàng
  activeCustomerSubscription = null;

  /// Danh sách tính năng của khách hàng
  customerFeatures = [];

  ///Danh sách cuộc họp
  meetingList = null;

  ///Thông tin khách hàng
  customer = null;

  ///mảng lưu các url được gọi
  playbackUrlArray = {};

  /// Mã màu cho trạng thái dung lượng của gói cước
  storageStatusColor = '#dc3545';

  /// Giá trị dung lượng cơ bản (gói cước)
  storageBaseValue: number = 0;

  /// Giá trị dung lượng đã sử dụng
  storageUsedValue: number = 0;

  /// Giá trị dung lượng tối đa + dung lượng đã mua thêm
  storageMaxValue: number = 0;

  /// Giá trị thời gian lưu trữ của dung lượng, mặc định: `util.getDefaultStorageRetention()`
  storageRetentionValue: number = 0;

  mounted() {
    this.getMeetingRecordings();
    this.checkUser();
  }

  onModalHidden() {
    this.$emit('closed');
  }
  /**
    * Lấy customerId
    */
  async checkUser() {
    const id = this.customerId ?? this.user?.customerId;
    if (!id) {
      return;
    }
    try {
      await this.fetchUser(id);
    } catch (error) {
      this.toastError(error);
    }
  }

  /**
   * Lấy thông tin lưu trữ theo gói cước(activeCustomerSubscription.storage.maxSize)
   * Lấy thông tin lưu trữ đã dùng(storageUsedValue)
   */
  async fetchUser(customerId) {
    this.isLoading = true;
    try {
      this.customer = await customerService.getDetails(customerId);
      const customerSubscriptions = await subscriptionPlanService.getCustomerSubscription(customerId);
      this.activeCustomerSubscription = customerSubscriptions.find(it => it.isActive);
      try {
        const customPack = await customerService.getCustomerFeature(customerId);
        this.customerFeatures = customPack?.features ?? [];
      } catch (e) {
        console.error("Failed to load customer features:", e);
        this.customerFeatures = [];
      }
      this.updateProps();
    } catch (e) {
      this.toastError(e);

    } finally {
      this.isLoading = false;
    }
  }
  /**
   * Cập nhật các props của modal
   */
  updateProps() {
      this.storageUsedValue = util.bytesToGB(this.customer?.usedStorageSize ?? 0, true, 2); //Dung lượng đã dùng
      // Dung lượng cơ bản
      this.storageBaseValue = util.bytesToGB(this.customer?.maxStorageSize ?? 0, true, 2);
      //Tổng dung lượng tối đa
      this.storageMaxValue = util.bytesToGB(util.getMaxStorage(this.customer?.maxStorageSize ?? 0, this.customer?.purchasedStorageSize ?? 0), true, 2);
      //Thời gian lưu trữ
      this.storageRetentionValue = this.activeCustomerSubscription?.retention ?? util.getDefaultStorageRetention();
      //Màu trạng thái dung lượng
      this.storageStatusColor = util.getStorageStatusColor(this.storageUsedValue, this.storageMaxValue);
  }

  /// AI Quota object từ customer
  get aiQuota() {
    return this.customer?.aiQuota ?? null;
  }

  get hasAIFeature(): boolean {
    return aiQuotaUtils.hasAIFeature(this.customerFeatures);
  }

  /// Kiểm tra có hiển thị AI Quota (nếu type = 0 hoặc type null/undefined thì không hiển thị)
  get showAiQuota(): boolean {
    return aiQuotaUtils.showAiQuota(this.hasAIFeature, this.aiQuota);
  }

  /// Kiểm tra AI không giới hạn (aiQuotaType === 3)
  get isAiUnlimited(): boolean {
    return aiQuotaUtils.isAiUnlimited(this.aiQuota);
  }

  /// Số phút AI Quota còn lại
  get aiQuotaRemainingMinutes(): number {
    return aiQuotaUtils.getAiQuotaRemainingMinutes(this.aiQuota);
  }

  /// Tổng hạn mức AI (baseAllocatedMinutes + purchasedMinutes)
  get aiQuotaTotalMinutes(): number {
    if (!this.aiQuota) return 0;
    const total = this.aiQuota.allocatedMinutes ?? 0;
    return Math.round(total * 100) / 100;
  }

  /// Giá trị max cho progress bar AI Quota
  get aiQuotaProgressMax(): number {
    return aiQuotaUtils.getAiQuotaProgressMax(this.aiQuota);
  }

  /// Giá trị value cho progress bar AI Quota
  get aiQuotaProgressValue(): number {
    return aiQuotaUtils.getAiQuotaProgressValue(this.aiQuota);
  }

  /// Số phút AI Quota đã sử dụng
  get aiQuotaUsedMinutes(): number {
    return aiQuotaUtils.getAiQuotaUsedMinutes(this.aiQuota);
  }

  /// Label phần trăm cho progress bar AI Quota
  get aiQuotaProgressLabel(): string {
    return aiQuotaUtils.getAiQuotaProgressLabel(this.aiQuota);
  }

  /// Ngày bắt đầu chu kỳ AI Quota (cycleEnd, format DD/MM/YYYY)
  get aiQuotaCycleStartFormatted(): string {
    return aiQuotaUtils.formatAiQuotaCycleStart(this.aiQuota?.cycleEnd);
  }

  /// Mã màu trạng thái AI Quota
  get aiQuotaStatusColor(): string {
    return aiQuotaUtils.getAiQuotaStatusColor(this.aiQuota);
  }
  /**
   * Lấy danh sách cuộc họp có recording
   */
  async getMeetingRecordings() {
    try {
      this.isLoading = true;
      const params = {
        status: '',
        page: 1,
        pageSize: 1000,
        isRecorded: 1,
        customerId: this.customerId ?? this.user?.customerId,
      };
      const result = await meetingService.getAllMeetings(params);
      this.meetingList = Array.isArray(result.data) ? result.data : [];
    } catch (e) {
      this.toastError(e);

    } finally {
      this.isLoading = false;
    }
  }
  /**
   * Getter danh sách cuộc họp có ghi hình
   */
  get meetingRecording() {
    return this.meetingList ?? [];
  }
  /**
   * Lấy ngày bắt đầu cuộc họp
   * @param startTime
   */
  getStartDate(startTime) {
    return moment(startTime).format("DD/MM/YY");
  }
  /**
   *Lấy dạng giờ 00h00
   * @param startTime
   */
  gettHour(startTime) {
    return moment(startTime).format("HH[h]mm");
  }
  /**
   * 
   */
  convertToByte(value) {
    return util.bytesToMB(value, true, 2);
  }
  /**
   * Xoá tất cả ghi hình cuộc họp (trong 90 ngày gần nhất)
   */
  async onClickDeleteAll() {
    const h = this.$createElement;

    const modalMessage = [h("div", [
      h("div", [this.$t("deleteAllRecordedConfirm") as string,]),
      h("p", [this.$t("attention") + ": ", h("em", this.$t("deleteRecordingWarning") as string)]),
    ])];
    const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'danger',
      okTitle: this.$t("yes").toString(),
      cancelTitle: this.$t("no").toString(),
    });

    if (confirmDelete) {
      try {
        await meetingService.deleteRecording(this.getUserCustomerId(), '*');
        await this.getMeetingRecordings();
        await this.checkUser();
        this.$bvModal.hide("manage-storage-modal");
        this.$emit('closed');
        this.toastSuccessDelay(this.$t("deleteRecordedSuccessfulAll").toString());
      } catch (e) {
        this.toastError(e);
      }
    }
  }

  /**
   * Xóa recorded
   */
  async onClickDeleteRecording(item) {
    const h = this.$createElement;

    const modalMessage = [h("div", [
      h("div", [this.$t("deleteThisRecordedConfirm", { name: item.name }) as string,]),
      h("p", [this.$t("attention") + ": ", h("em", this.$t("deleteRecordingWarning") as string)]),
    ])];

    const confirmDelete = await this.$bvModal.msgBoxConfirm(modalMessage, {
      okVariant: 'danger',
      okTitle: this.$t('yes').toString(),
      cancelTitle: this.$t('no').toString(),
      html: true
    });

    if (confirmDelete) {
      try {
        this.showLoading();
        await meetingService.deleteRecording(this.getUserCustomerId(), item.internalMeetingId);
        await this.getMeetingRecordings();
        await this.checkUser();
        this.toastSuccessDelay(this.$t("deleteRecordedSuccessful").toString());
      } catch (e) {
        this.toastError(e);
      } finally {
        this.hideLoading();
      }
    }
  }
  /**
   * Lấy playbackUrl từ API
   */
  async getPlaybackUrl(item) {
    try {
      const playbackUrl = (await meetingService.getMeetingRecording(item.id)).playbackUrl ?? null;
      if (playbackUrl) {
        this.playbackUrlArray[item.id] = playbackUrl; // lưu cache
      }
      return playbackUrl;
    } catch (e) {
      this.toastError(e);
      return null;
    }
  }
  //lấy file record cuộc họp
  async loadRecordingUrl(item) {
    this.isLoading = true;
    try {
      const res = this.playbackUrlArray[item.id] || await this.getPlaybackUrl(item);
      if (res) {
        window.open(res, "_blank");
      }
    } catch (e) {
      this.toastError(e);
    } finally {
      this.isLoading = false;
    }
  }
  // Tải file record cuộc họp
  async onClickDownload(item) {
    this.isLoading = true;
    try {
      const url = this.playbackUrlArray[item.id] || await this.getPlaybackUrl(item);
      if (!url) {
        this.toastError({ code: "cannotGetDownloadLink" });
        return;
      }
      const safeName = item.name ? item.name.replace(/\//g, '_') : '';
      const fileName = `${item.id}_Recording_${safeName}.mp4`;
      await util.downloadFile(url, fileName, () => {
        window.open(url, "_blank");
      });
    } catch (e) {
      this.toastError({ code: "cannotGetDownloadLink" });
      console.error("Error downloading recording:", e);
    } finally {
      this.isLoading = false;
    }
  }
}
</script>